import { internal, template } from '../../vendor/elix.js';

function HelperTextMixin(Base) {
  
  return class HelperText extends Base {

    static get observedAttributes() {
      return [
        ...super.observedAttributes,
        'helpertext'
      ];
    }

    get [internal.defaultState]() {
      return Object.assign(
        {},
        super[internal.defaultState],
        { helpertext: undefined }
      );
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
      super.attributeChangedCallback(attributeName, oldValue, newValue);
      if (attributeName === 'helpertext') {
        this.helpertext = newValue;
      }
    }

    get helpertext() {
      return this[internal.state].helpertext;
    }

    set helpertext(helpertext) {
      this[internal.setState]({ helpertext });
    }

    [internal.render](changed) {

      super[internal.render](changed);

      if (changed.helpertext) {
        this.renderHelperText();
      }

    }

    renderHelperText() {
      const helperTextElement = this.shadowRoot.querySelector('.helpertext');
      if (this.helpertext && !this.errortext) {
        helperTextElement.classList.add('visible');
        helperTextElement.textContent = this.helpertext;
      } else {
        helperTextElement.classList.remove('visible');
        helperTextElement.textContent = '';
      }
    }

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

        <style>

          .helpertext {
            --webkit-font-smoothing: antialiased;
            color: var(--tp-helper-text-mixin-font-color);
            display: none;
            font-family: var(--tp-helper-text-mixin-font-family);
            font-size: var(--tp-helper-text-mixin-font-size);
            letter-spacing: 0.77px;
            overflow: hidden;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .inputStateContainer:not(.error) .helpertext.visible,
          .inputStateContainer:not(.error) ~ .helpertext.visible{
            display: block;
          }

          .inputStateContainer.disabled .helpertext,
          .inputStateContainer.disabled ~ .helpertext{
            color: var(--tp-helper-text-mixin-font-color-disabled);
          }

          .inputStateContainer:not(.disabled):not(.error):hover .helpertext,
          .inputStateContainer:not(.disabled):not(.error):hover ~ .helpertext {
            color: var(--tp-helper-text-mixin-font-color-hover);
          }

          .inputStateContainer:not(.disabled):not(.error).focused .helpertext,
          .inputStateContainer:not(.disabled):not(.error).focused ~ .helpertext {
            color: var(--tp-helper-text-mixin-font-color-focused);
          }
        </style>

        <div class='helpertext'></div>
        `
      );

    }

  }
}

export default HelperTextMixin;
